// If any import references a json file it scerws up auto import
// Don't put anything else in here
import App from './saved-filters.config.json';
export const savedFilterAppConfig = App.App;
